const createMoldalForVideo = async (url) => {
  return `
  <section class="container">
    <div class="col-11 col-md-8 mx-auto modalVideo__body px-0">
      <div class="videoWrapper">
        <iframe width="560"
          loading="lazy"
          height="349"
          src="${url}"
          frameborder="0"
          allowfullscreen>
        </iframe>
      </div>
    </div>
    <div class="col-11 col-md-8 modalVideo__close pt-4 mx-auto">
      <button onclick="closeModalVideo()" class="modalVideo__close--btn">
        X
      </button>
    </div>
  </section>
  `;
};

const destroyModal = async () => {
  try {
    let modal = document.querySelector(".modalVideo");
    if (!modal) return;
    modal.remove();
  } catch (Exception) {
    console.warn("Exception in destroyModal => " + Exception);
  }
};
window.createModalVideo = async function (event, url = "") {
  try {
    event.preventDefault();
    if (!url) return;
    await destroyModal();
    let modalInner = await createMoldalForVideo(url);
    let modalElement = document.createElement("article");
    modalElement.classList.add("modalVideo");
    modalElement.innerHTML = modalInner;
    document.body.appendChild(modalElement);
  } catch (Exception) {
    console.warn("Exception in createModalVideo => " + Exception);
  }
};

window.closeModalVideo = function () {
  try {
    destroyModal();
  } catch (Exception) {
    console.warn("Exception in closeModalVideo => " + Exception);
  }
};
